"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRubyClient = void 0;
const api_1 = require("./api");
const spi_1 = require("./spi");
function createRubyClient(networkClient) {
    return {
        api: (0, api_1.createRubyApiClient)(networkClient),
        spi: (0, spi_1.createRubySpiClient)(networkClient),
    };
}
exports.createRubyClient = createRubyClient;
